const locales = ['en', 'ja', 'zh-CN', 'zh-TW', 'fr', 'es', 'ko'];
const entries = {
  "forum.seoTitle": [
    "Community Forum",
    "コミュニティフォーラム",
    "社区论坛",
    "社群論壇",
    "Forum communautaire",
    "Foro de la comunidad",
    "커뮤니티 포럼"
  ],
  "forum.seoDescription": [
    "Share yo-yo stories, discuss tricks, and connect with the YCH-YOYO community.",
    "ヨーヨーの体験やトリックを共有し、YCH-YOYOの仲間と交流しましょう。",
    "分享悠悠球故事、交流技巧，与 YCH-YOYO 社区玩家互动。",
    "分享溜溜球故事、交流技巧，與 YCH-YOYO 社群玩家互動。",
    "Partagez vos histoires et astuces de yo-yo avec la communauté YCH-YOYO.",
    "Comparte historias y trucos de yo-yo con la comunidad YCH-YOYO.",
    "요요 이야기와 기술을 나누고 YCH-YOYO 커뮤니티와 소통하세요."
  ],
  "forum.eyebrow": [
    "THE YCH-YOYO COMMUNITY",
    "YCH-YOYO コミュニティ",
    "YCH-YOYO 玩家社区",
    "YCH-YOYO 玩家社群",
    "LA COMMUNAUTÉ YCH-YOYO",
    "LA COMUNIDAD YCH-YOYO",
    "YCH-YOYO 커뮤니티"
  ],
  "forum.hero": [
    "More than a throw.",
    "スローの先に、つながりを。",
    "不止于一次抛投。",
    "不止於一次拋投。",
    "Bien plus qu’un lancer.",
    "Más que un lanzamiento.",
    "한 번의 스로우, 그 이상의 이야기."
  ],
  "forum.detailHero": [
    "From the community.",
    "コミュニティからの声。",
    "来自社区的分享。",
    "來自社群的分享。",
    "Les voix de la communauté.",
    "Voces de la comunidad.",
    "커뮤니티의 이야기."
  ],
  "forum.intro": [
    "Stories, discoveries, and conversations. A place for every yo-yo player.",
    "体験、発見、そして会話。すべてのヨーヨープレイヤーの居場所。",
    "故事、发现与交流。属于每一位悠悠球玩家的空间。",
    "故事、發現與交流。屬於每一位溜溜球玩家的空間。",
    "Histoires, découvertes et échanges. Un espace pour chaque joueur de yo-yo.",
    "Historias, descubrimientos y conversaciones. Un espacio para cada jugador de yo-yo.",
    "이야기와 발견, 그리고 대화. 모든 요요 플레이어를 위한 공간."
  ],
  "forum.write": [
    "Write an article ↗",
    "記事を書く ↗",
    "写文章 ↗",
    "寫文章 ↗",
    "Écrire un article ↗",
    "Escribir un artículo ↗",
    "글 쓰기 ↗"
  ],
  "forum.close": [
    "Close editor",
    "エディターを閉じる",
    "关闭编辑器",
    "關閉編輯器",
    "Fermer l’éditeur",
    "Cerrar editor",
    "편집기 닫기"
  ],
  "forum.retry": [
    "Retry loading",
    "再読み込み",
    "重新加载",
    "重新載入",
    "Réessayer",
    "Volver a cargar",
    "다시 불러오기"
  ],
  "forum.editorTitle": [
    "Share your story",
    "あなたの体験を共有",
    "分享你的故事",
    "分享你的故事",
    "Partagez votre histoire",
    "Comparte tu historia",
    "나의 이야기 공유"
  ],
  "forum.rules": [
    "Keep it respectful. No spam, harassment, or personal information.",
    "互いを尊重しましょう。スパム、嫌がらせ、個人情報の投稿は禁止です。",
    "请友善交流，不要发布垃圾信息、骚扰内容或个人隐私。",
    "請友善交流，不要發布垃圾訊息、騷擾內容或個人隱私。",
    "Restez respectueux. Pas de spam, de harcèlement ni d’informations personnelles.",
    "Mantén el respeto. No publiques spam, acoso ni información personal.",
    "서로 존중해 주세요. 스팸, 괴롭힘, 개인정보 게시를 금지합니다."
  ],
  "forum.title": [
    "Title",
    "タイトル",
    "标题",
    "標題",
    "Titre",
    "Título",
    "제목"
  ],
  "forum.body": [
    "Article",
    "本文",
    "正文",
    "內文",
    "Article",
    "Artículo",
    "본문"
  ],
  "forum.images": [
    "Photos",
    "写真",
    "图片",
    "圖片",
    "Photos",
    "Fotos",
    "사진"
  ],
  "forum.addImages": [
    "Add photos",
    "写真を追加",
    "添加图片",
    "新增圖片",
    "Ajouter des photos",
    "Añadir fotos",
    "사진 추가"
  ],
  "forum.imageHint": [
    "Up to {{count}} photos. JPEG, PNG or WebP, up to {{sourceLimit}} MB each; automatically compressed to {{limit}} KB or less.",
    "写真は最大{{count}}枚。JPEG、PNG、WebP形式で、1枚あたり{{sourceLimit}} MBまで。{{limit}} KB以下に自動圧縮されます。",
    "最多添加 {{count}} 张图片，支持 JPEG、PNG 或 WebP，原图每张不超过 {{sourceLimit}} MB；将自动压缩至 {{limit}} KB 以内。",
    "最多新增 {{count}} 張圖片，支援 JPEG、PNG 或 WebP，原圖每張不超過 {{sourceLimit}} MB；將自動壓縮至 {{limit}} KB 以內。",
    "Jusqu’à {{count}} photos au format JPEG, PNG ou WebP, de {{sourceLimit}} Mo maximum chacune ; compression automatique à {{limit}} Ko ou moins.",
    "Hasta {{count}} fotos JPEG, PNG o WebP, de un máximo de {{sourceLimit}} MB cada una; se comprimen automáticamente a {{limit}} KB o menos.",
    "JPEG, PNG 또는 WebP 사진을 최대 {{count}}장 추가할 수 있습니다. 사진당 최대 {{sourceLimit}} MB이며, {{limit}} KB 이하로 자동 압축됩니다."
  ],
  "forum.preparingImages": [
    "Preparing photos…",
    "写真を準備中…",
    "正在处理图片…",
    "正在處理圖片…",
    "Préparation des photos…",
    "Preparando fotos…",
    "사진 준비 중…"
  ],
  "forum.removeImage": [
    "Remove photo {{number}}",
    "写真{{number}}を削除",
    "移除图片 {{number}}",
    "移除圖片 {{number}}",
    "Retirer la photo {{number}}",
    "Quitar foto {{number}}",
    "사진 {{number}} 삭제"
  ],
  "forum.imageAlt": [
    "Photo {{number}}",
    "写真{{number}}",
    "图片 {{number}}",
    "圖片 {{number}}",
    "Photo {{number}}",
    "Foto {{number}}",
    "사진 {{number}}"
  ],
  "forum.imageSize": [
    "{{size}} KB",
    "{{size}} KB",
    "{{size}} KB",
    "{{size}} KB",
    "{{size}} Ko",
    "{{size}} KB",
    "{{size}} KB"
  ],
  "forum.placeholder": [
    "What have you been working on?",
    "最近どんなことに取り組んでいますか？",
    "最近在练习或探索什么？",
    "最近在練習或探索什麼？",
    "Sur quoi travaillez-vous en ce moment ?",
    "¿En qué has estado trabajando?",
    "요즘 어떤 것을 연습하고 있나요?"
  ],
  "forum.characters": [
    "{{count}} / {{limit}} characters · Plain text",
    "{{count}} / {{limit}} 文字 · プレーンテキスト",
    "{{count}} / {{limit}} 字符 · 纯文本",
    "{{count}} / {{limit}} 字元 · 純文字",
    "{{count}} / {{limit}} caractères · Texte brut",
    "{{count}} / {{limit}} caracteres · Texto sin formato",
    "{{count}} / {{limit}}자 · 일반 텍스트"
  ],
  "forum.publishing": [
    "Publishing…",
    "公開中…",
    "发布中…",
    "發布中…",
    "Publication…",
    "Publicando…",
    "게시 중…"
  ],
  "forum.publish": [
    "Publish article",
    "記事を公開",
    "发布文章",
    "發布文章",
    "Publier l’article",
    "Publicar artículo",
    "글 게시"
  ],
  "forum.loading": [
    "Loading community…",
    "コミュニティを読み込み中…",
    "正在加载社区…",
    "正在載入社群…",
    "Chargement de la communauté…",
    "Cargando comunidad…",
    "커뮤니티 불러오는 중…"
  ],
  "forum.all": [
    "← All articles",
    "← すべての記事",
    "← 全部文章",
    "← 全部文章",
    "← Tous les articles",
    "← Todos los artículos",
    "← 모든 글"
  ],
  "forum.member": [
    "Community Member",
    "コミュニティメンバー",
    "社区成员",
    "社群成員",
    "Membre de la communauté",
    "Miembro de la comunidad",
    "커뮤니티 회원"
  ],
  "forum.liked": [
    "♥ Liked",
    "♥ いいね済み",
    "♥ 已点赞",
    "♥ 已按讚",
    "♥ Aimé",
    "♥ Te gusta",
    "♥ 좋아요 표시됨"
  ],
  "forum.like": [
    "♡ Like",
    "♡ いいね",
    "♡ 点赞",
    "♡ 按讚",
    "♡ J’aime",
    "♡ Me gusta",
    "♡ 좋아요"
  ],
  "forum.comments": [
    "Comments · {{count}}",
    "コメント · {{count}}",
    "评论 · {{count}}",
    "留言 · {{count}}",
    "Commentaires · {{count}}",
    "Comentarios · {{count}}",
    "댓글 · {{count}}"
  ],
  "forum.share": [
    "Share ↗",
    "共有 ↗",
    "分享 ↗",
    "分享 ↗",
    "Partager ↗",
    "Compartir ↗",
    "공유 ↗"
  ],
  "forum.deleteArticle": [
    "Delete this article?",
    "この記事を削除しますか？",
    "删除这篇文章？",
    "刪除這篇文章？",
    "Supprimer cet article ?",
    "¿Eliminar este artículo?",
    "이 글을 삭제할까요?"
  ],
  "forum.deleteComment": [
    "Delete this comment?",
    "このコメントを削除しますか？",
    "删除这条评论？",
    "刪除這則留言？",
    "Supprimer ce commentaire ?",
    "¿Eliminar este comentario?",
    "이 댓글을 삭제할까요?"
  ],
  "forum.conversation": [
    "Conversation",
    "会話",
    "讨论",
    "討論",
    "Discussion",
    "Conversación",
    "대화"
  ],
  "forum.addComment": [
    "Add a comment",
    "コメントを書く",
    "添加评论",
    "新增留言",
    "Ajouter un commentaire",
    "Añadir un comentario",
    "댓글 작성"
  ],
  "forum.postComment": [
    "Post comment",
    "コメントを投稿",
    "发表评论",
    "發表留言",
    "Publier le commentaire",
    "Publicar comentario",
    "댓글 게시"
  ],
  "forum.login": [
    "Sign in to like articles and join the conversation.",
    "ログインして、いいねやコメントで参加しましょう。",
    "登录后即可点赞文章并参与讨论。",
    "登入後即可為文章按讚並參與討論。",
    "Connectez-vous pour aimer les articles et participer à la discussion.",
    "Inicia sesión para dar me gusta y participar en la conversación.",
    "로그인하여 글에 좋아요를 누르고 대화에 참여하세요."
  ],
  "forum.noComments": [
    "No comments yet. Start the conversation.",
    "まだコメントはありません。会話を始めましょう。",
    "还没有评论，来聊两句吧。",
    "還沒有留言，來聊兩句吧。",
    "Aucun commentaire. Lancez la discussion.",
    "Aún no hay comentarios. Inicia la conversación.",
    "아직 댓글이 없습니다. 대화를 시작해 보세요."
  ],
  "forum.moreComments": [
    "More comments",
    "コメントをもっと見る",
    "更多评论",
    "更多留言",
    "Plus de commentaires",
    "Más comentarios",
    "댓글 더 보기"
  ],
  "forum.latest": [
    "Latest articles",
    "最新の記事",
    "最新文章",
    "最新文章",
    "Derniers articles",
    "Artículos recientes",
    "최신 글"
  ],
  "forum.byPlayers": [
    "By the players. For the players.",
    "プレイヤーから、プレイヤーへ。",
    "由玩家分享，为玩家而写。",
    "由玩家分享，為玩家而寫。",
    "Par les joueurs. Pour les joueurs.",
    "Por los jugadores. Para los jugadores.",
    "플레이어가 쓰고, 플레이어가 읽는 이야기."
  ],
  "forum.emptyTitle": [
    "The conversation starts with you.",
    "あなたから、会話が始まる。",
    "交流，从你开始。",
    "交流，從你開始。",
    "La discussion commence avec vous.",
    "La conversación empieza contigo.",
    "대화는 당신으로부터 시작됩니다."
  ],
  "forum.emptyBody": [
    "Share a trick breakdown, a competition story, or your latest discovery.",
    "トリックの解説、大会の体験、最新の発見を共有しましょう。",
    "分享技巧解析、比赛故事，或你的最新发现。",
    "分享技巧解析、比賽故事，或你的最新發現。",
    "Partagez une analyse de figure, un récit de compétition ou une découverte.",
    "Comparte un análisis de un truco, una historia de competición o un descubrimiento.",
    "기술 분석, 대회 이야기 또는 새로운 발견을 공유하세요."
  ],
  "forum.read": [
    "Read article ↗",
    "記事を読む ↗",
    "阅读全文 ↗",
    "閱讀全文 ↗",
    "Lire l’article ↗",
    "Leer artículo ↗",
    "글 읽기 ↗"
  ],
  "forum.more": [
    "More articles",
    "記事をもっと見る",
    "更多文章",
    "更多文章",
    "Plus d’articles",
    "Más artículos",
    "글 더 보기"
  ],
  "forum.stats": [
    "♡ {{likes}} likes · {{comments}} comments",
    "♡ いいね {{likes}} · コメント {{comments}}",
    "♡ {{likes}} 次点赞 · {{comments}} 条评论",
    "♡ {{likes}} 次按讚 · {{comments}} 則留言",
    "♡ {{likes}} mentions J’aime · {{comments}} commentaires",
    "♡ {{likes}} me gusta · {{comments}} comentarios",
    "♡ 좋아요 {{likes}}개 · 댓글 {{comments}}개"
  ],
  "forum.copied": [
    "Article link copied.",
    "記事のリンクをコピーしました。",
    "文章链接已复制。",
    "文章連結已複製。",
    "Lien de l’article copié.",
    "Enlace del artículo copiado.",
    "글 링크를 복사했습니다."
  ],
  "forum.copyPrompt": [
    "Copy this article link to share:",
    "この記事のリンクをコピーして共有：",
    "复制文章链接进行分享：",
    "複製文章連結進行分享：",
    "Copiez ce lien pour partager l’article :",
    "Copia este enlace para compartir:",
    "이 글 링크를 복사하여 공유하세요:"
  ],
  "forum.reportPrompt": [
    "Choose a report reason by number:\n{{reasons}}",
    "報告理由の番号を入力してください：\n{{reasons}}",
    "请输入举报原因对应的数字：\n{{reasons}}",
    "請輸入檢舉原因對應的數字：\n{{reasons}}",
    "Saisissez le numéro du motif :\n{{reasons}}",
    "Introduce el número del motivo:\n{{reasons}}",
    "신고 사유의 번호를 입력하세요:\n{{reasons}}"
  ],
  "forum.error.generic": [
    "Unable to complete the request. Please try again.",
    "リクエストを完了できません。もう一度お試しください。",
    "操作失败，请重试。",
    "操作失敗，請重試。",
    "Impossible de terminer la demande. Réessayez.",
    "No se pudo completar la solicitud. Inténtalo de nuevo.",
    "요청을 완료하지 못했습니다. 다시 시도해 주세요."
  ],
  "forum.error.auth": [
    "Please sign in again to continue.",
    "続行するには再度ログインしてください。",
    "请重新登录后继续。",
    "請重新登入後繼續。",
    "Reconnectez-vous pour continuer.",
    "Vuelve a iniciar sesión para continuar.",
    "계속하려면 다시 로그인하세요."
  ],
  "forum.error.forbidden": [
    "You do not have permission to perform this action.",
    "この操作を行う権限がありません。",
    "你没有权限执行此操作。",
    "你沒有權限執行此操作。",
    "Vous n’avez pas l’autorisation d’effectuer cette action.",
    "No tienes permiso para realizar esta acción.",
    "이 작업을 수행할 권한이 없습니다."
  ],
  "forum.error.notFound": [
    "This content is no longer available.",
    "このコンテンツは利用できなくなりました。",
    "此内容已不可用。",
    "此內容已無法存取。",
    "Ce contenu n’est plus disponible.",
    "Este contenido ya no está disponible.",
    "이 콘텐츠는 더 이상 볼 수 없습니다."
  ],
  "forum.error.rate": [
    "Too many requests. Please try again later.",
    "リクエストが多すぎます。しばらくしてからお試しください。",
    "操作过于频繁，请稍后再试。",
    "操作過於頻繁，請稍後再試。",
    "Trop de demandes. Réessayez plus tard.",
    "Demasiadas solicitudes. Inténtalo más tarde.",
    "요청이 너무 많습니다. 잠시 후 다시 시도하세요."
  ],
  "forum.error.invalid": [
    "Check your input: title 1–160 characters, article 1–20,000 characters, comment 1–1,000 characters. Choose report reason 1–4.",
    "入力を確認してください。タイトルは1〜160文字、本文は1〜20,000文字、コメントは1〜1,000文字、報告理由は1〜4です。",
    "请检查输入：标题 1–160 字符，正文 1–20,000 字符，评论 1–1,000 字符；举报原因请选择 1–4。",
    "請檢查輸入：標題 1–160 字元，內文 1–20,000 字元，留言 1–1,000 字元；檢舉原因請選擇 1–4。",
    "Vérifiez la saisie : titre de 1 à 160 caractères, article de 1 à 20 000, commentaire de 1 à 1 000. Motif de signalement de 1 à 4.",
    "Revisa los datos: título de 1 a 160 caracteres, artículo de 1 a 20 000, comentario de 1 a 1000. Motivo de denuncia del 1 al 4.",
    "입력 내용을 확인하세요. 제목 1~160자, 본문 1~20,000자, 댓글 1~1,000자, 신고 사유 1~4번입니다."
  ],
  "forum.error.large": [
    "The request is too large. Please shorten your text.",
    "リクエストが大きすぎます。文章を短くしてください。",
    "请求内容过大，请缩短文字。",
    "請求內容過大，請縮短文字。",
    "La demande est trop volumineuse. Raccourcissez le texte.",
    "La solicitud es demasiado grande. Acorta el texto.",
    "요청이 너무 큽니다. 글을 줄여 주세요."
  ],
  "forum.error.invalidImage": [
    "Choose a valid JPEG, PNG or WebP image.",
    "有効なJPEG、PNG、WebP形式の画像を選んでください。",
    "请选择有效的 JPEG、PNG 或 WebP 图片。",
    "請選擇有效的 JPEG、PNG 或 WebP 圖片。",
    "Choisissez une image JPEG, PNG ou WebP valide.",
    "Elige una imagen JPEG, PNG o WebP válida.",
    "유효한 JPEG, PNG 또는 WebP 이미지를 선택하세요."
  ],
  "forum.error.imageSourceLarge": [
    "Choose an image smaller than {{limit}} MB.",
    "{{limit}} MB未満の画像を選んでください。",
    "请选择小于 {{limit}} MB 的图片。",
    "請選擇小於 {{limit}} MB 的圖片。",
    "Choisissez une image de moins de {{limit}} Mo.",
    "Elige una imagen de menos de {{limit}} MB.",
    "{{limit}} MB 미만의 이미지를 선택하세요."
  ],
  "forum.error.imageDimensions": [
    "This image has too many pixels. Choose an image up to {{limit}} megapixels.",
    "画像の画素数が多すぎます。{{limit}}メガピクセル以下の画像を選んでください。",
    "这张图片的像素过多，请选择不超过 {{limit}} 百万像素的图片。",
    "這張圖片的像素過多，請選擇不超過 {{limit}} 百萬像素的圖片。",
    "Cette image contient trop de pixels. Choisissez une image de {{limit}} mégapixels maximum.",
    "Esta imagen tiene demasiados píxeles. Elige una imagen de hasta {{limit}} megapíxeles.",
    "이미지의 픽셀 수가 너무 많습니다. {{limit}}메가픽셀 이하의 이미지를 선택하세요."
  ],
  "forum.error.imageCompression": [
    "Unable to prepare this image. Try a smaller image.",
    "この画像を処理できません。より小さい画像をお試しください。",
    "无法处理这张图片，请换一张较小的图片。",
    "無法處理這張圖片，請換一張較小的圖片。",
    "Impossible de préparer cette image. Essayez une image plus petite.",
    "No se pudo preparar esta imagen. Prueba con una más pequeña.",
    "이미지를 준비하지 못했습니다. 더 작은 이미지로 다시 시도하세요."
  ],
  "forum.error.tooManyImages": [
    "You can add up to {{count}} photos per article.",
    "1つの記事に追加できる写真は最大{{count}}枚です。",
    "每篇文章最多添加 {{count}} 张图片。",
    "每篇文章最多新增 {{count}} 張圖片。",
    "Vous pouvez ajouter jusqu’à {{count}} photos par article.",
    "Puedes añadir hasta {{count}} fotos por artículo.",
    "글 하나에 사진을 최대 {{count}}장 추가할 수 있습니다."
  ],
  "forum.error.imageTooLarge": [
    "Each prepared photo must be {{limit}} KB or less. Please choose it again.",
    "処理後の写真は1枚あたり{{limit}} KB以下にしてください。もう一度選んでください。",
    "处理后的图片每张必须不超过 {{limit}} KB，请重新选择。",
    "處理後的圖片每張必須不超過 {{limit}} KB，請重新選擇。",
    "Chaque photo préparée doit faire {{limit}} Ko ou moins. Sélectionnez-la à nouveau.",
    "Cada foto preparada debe ocupar {{limit}} KB o menos. Vuelve a seleccionarla.",
    "준비된 사진은 각각 {{limit}} KB 이하여야 합니다. 다시 선택해 주세요."
  ],
  "forum.error.conflict": [
    "You have already reported this content.",
    "このコンテンツはすでに報告済みです。",
    "你已经举报过此内容。",
    "你已經檢舉過此內容。",
    "Vous avez déjà signalé ce contenu.",
    "Ya has denunciado este contenido.",
    "이미 신고한 콘텐츠입니다."
  ]
};

export const forumTranslations = Object.fromEntries(locales.map((locale, index) => [locale,
  Object.fromEntries(Object.entries(entries).map(([key, values]) => [key, values[index]])),
]));
